var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('KTCodePreview',{attrs:{"title":'Alumni Siswa'},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('v-row',{staticClass:"mb-4"},[_c('v-col',{attrs:{"cols":"12","md":"12"}}),_c('CardBukuWisudawan',{attrs:{"data":_vm.dataCard}})],1)]},proxy:true}])})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }